export const emart = {
  color: "yellow-c-emart",
  hex: "#FFCF02",
};
